// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme Variables */
.dark-theme {
  --bg-primary: #0f1419;
  --bg-secondary: #1a1d29;
  --bg-tertiary: #2d3343;
  --text-primary: #fff;
  --text-secondary: #8b92a7;
  --text-muted: #6c757d;
  --border-color: #2d3343;
  --card-bg: #1a1d29;
  --modal-bg: #1a1d29;
  --success-color: #28a745;
  --danger-color: #dc3545;
  --warning-color: #ffc107;
  --info-color: #17a2b8;
  --primary-color: #4f9eff;
}

.light-theme {
  --bg-primary: #f8f9fa;
  --bg-secondary: #ffffff;
  --bg-tertiary: #e9ecef;
  --text-primary: #212529;
  --text-secondary: #495057;
  --text-muted: #6c757d;
  --border-color: #dee2e6;
  --card-bg: #ffffff;
  --modal-bg: #ffffff;
  --success-color: #28a745;
  --danger-color: #dc3545;
  --warning-color: #ffc107;
  --info-color: #17a2b8;
  --primary-color: #007bff;
}

/* Global Styles */
body.dark-theme,
body.light-theme {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Bootstrap Overrides */
.dark-theme .card,
.light-theme .card {
  background-color: var(--card-bg);
  color: var(--text-primary);
  border-color: var(--border-color);
}

.dark-theme .modal-content,
.light-theme .modal-content {
  background-color: var(--modal-bg);
  color: var(--text-primary);
  border-color: var(--border-color);
}

.dark-theme .modal-header,
.dark-theme .modal-footer,
.light-theme .modal-header,
.light-theme .modal-footer {
  border-color: var(--border-color);
}

.dark-theme .bg-dark,
.light-theme .bg-dark {
  background-color: var(--bg-secondary) !important;
}

.dark-theme .bg-secondary,
.light-theme .bg-secondary {
  background-color: var(--bg-tertiary) !important;
}

.dark-theme .text-white,
.light-theme .text-white {
  color: var(--text-primary) !important;
}

.dark-theme .text-muted,
.light-theme .text-muted {
  color: var(--text-muted) !important;
}

.dark-theme .navbar,
.light-theme .navbar {
  background-color: var(--bg-secondary) !important;
  border-bottom: 1px solid var(--border-color);
}

.dark-theme .navbar-brand,
.dark-theme .nav-link,
.light-theme .navbar-brand,
.light-theme .nav-link {
  color: var(--text-primary) !important;
}

.dark-theme .form-control,
.dark-theme .form-select,
.light-theme .form-control,
.light-theme .form-select {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

.dark-theme .form-control:focus,
.dark-theme .form-select:focus,
.light-theme .form-control:focus,
.light-theme .form-select:focus {
  background-color: var(--bg-tertiary);
  border-color: var(--primary-color);
  color: var(--text-primary);
}

/* Theme Toggle Button */
.theme-toggle-btn {
  background: transparent;
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  padding: 0.375rem 0.75rem;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.theme-toggle-btn:hover {
  background-color: var(--bg-tertiary);
  border-color: var(--primary-color);
}

/* Cards Component Specific */
.dark-theme .hover-shadow:hover,
.light-theme .hover-shadow:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

/* Success/Error Colors */
.text-success {
  color: var(--success-color) !important;
}

.text-danger {
  color: var(--danger-color) !important;
}

.text-warning {
  color: var(--warning-color) !important;
}

.text-info {
  color: var(--info-color) !important;
}

/* Modal Close Button */
.dark-theme .btn-close {
  filter: invert(1);
}

/* Card Details Modal Specific */
.dark-theme .modal .card,
.light-theme .modal .card {
  background-color: var(--bg-tertiary) !important;
}

/* Badge Colors in Theme */
.dark-theme .badge,
.light-theme .badge {
  opacity: 0.9;
}

/* Nav Pills */
.dark-theme .nav-pills .nav-link,
.light-theme .nav-pills .nav-link {
  color: var(--text-primary);
}

.dark-theme .nav-pills .nav-link.active,
.light-theme .nav-pills .nav-link.active {
  background-color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./src/theme.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;;EAEE,mCAAmC;EACnC,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA,wBAAwB;AACxB;;EAEE,gCAAgC;EAChC,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;;EAEE,iCAAiC;EACjC,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;;;;EAIE,iCAAiC;AACnC;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,gDAAgD;EAChD,4CAA4C;AAC9C;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA;;;;EAIE,oCAAoC;EACpC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;;;;EAIE,oCAAoC;EACpC,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,uBAAuB;EACvB,qCAAqC;EACrC,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA,6BAA6B;AAC7B;;EAEE,wDAAwD;AAC1D;;AAEA,yBAAyB;AACzB;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;;EAEE,+CAA+C;AACjD;;AAEA,0BAA0B;AAC1B;;EAEE,YAAY;AACd;;AAEA,cAAc;AACd;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,sCAAsC;AACxC","sourcesContent":["/* Theme Variables */\n.dark-theme {\n  --bg-primary: #0f1419;\n  --bg-secondary: #1a1d29;\n  --bg-tertiary: #2d3343;\n  --text-primary: #fff;\n  --text-secondary: #8b92a7;\n  --text-muted: #6c757d;\n  --border-color: #2d3343;\n  --card-bg: #1a1d29;\n  --modal-bg: #1a1d29;\n  --success-color: #28a745;\n  --danger-color: #dc3545;\n  --warning-color: #ffc107;\n  --info-color: #17a2b8;\n  --primary-color: #4f9eff;\n}\n\n.light-theme {\n  --bg-primary: #f8f9fa;\n  --bg-secondary: #ffffff;\n  --bg-tertiary: #e9ecef;\n  --text-primary: #212529;\n  --text-secondary: #495057;\n  --text-muted: #6c757d;\n  --border-color: #dee2e6;\n  --card-bg: #ffffff;\n  --modal-bg: #ffffff;\n  --success-color: #28a745;\n  --danger-color: #dc3545;\n  --warning-color: #ffc107;\n  --info-color: #17a2b8;\n  --primary-color: #007bff;\n}\n\n/* Global Styles */\nbody.dark-theme,\nbody.light-theme {\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Bootstrap Overrides */\n.dark-theme .card,\n.light-theme .card {\n  background-color: var(--card-bg);\n  color: var(--text-primary);\n  border-color: var(--border-color);\n}\n\n.dark-theme .modal-content,\n.light-theme .modal-content {\n  background-color: var(--modal-bg);\n  color: var(--text-primary);\n  border-color: var(--border-color);\n}\n\n.dark-theme .modal-header,\n.dark-theme .modal-footer,\n.light-theme .modal-header,\n.light-theme .modal-footer {\n  border-color: var(--border-color);\n}\n\n.dark-theme .bg-dark,\n.light-theme .bg-dark {\n  background-color: var(--bg-secondary) !important;\n}\n\n.dark-theme .bg-secondary,\n.light-theme .bg-secondary {\n  background-color: var(--bg-tertiary) !important;\n}\n\n.dark-theme .text-white,\n.light-theme .text-white {\n  color: var(--text-primary) !important;\n}\n\n.dark-theme .text-muted,\n.light-theme .text-muted {\n  color: var(--text-muted) !important;\n}\n\n.dark-theme .navbar,\n.light-theme .navbar {\n  background-color: var(--bg-secondary) !important;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.dark-theme .navbar-brand,\n.dark-theme .nav-link,\n.light-theme .navbar-brand,\n.light-theme .nav-link {\n  color: var(--text-primary) !important;\n}\n\n.dark-theme .form-control,\n.dark-theme .form-select,\n.light-theme .form-control,\n.light-theme .form-select {\n  background-color: var(--bg-tertiary);\n  border-color: var(--border-color);\n  color: var(--text-primary);\n}\n\n.dark-theme .form-control:focus,\n.dark-theme .form-select:focus,\n.light-theme .form-control:focus,\n.light-theme .form-select:focus {\n  background-color: var(--bg-tertiary);\n  border-color: var(--primary-color);\n  color: var(--text-primary);\n}\n\n/* Theme Toggle Button */\n.theme-toggle-btn {\n  background: transparent;\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n  padding: 0.375rem 0.75rem;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.theme-toggle-btn:hover {\n  background-color: var(--bg-tertiary);\n  border-color: var(--primary-color);\n}\n\n/* Cards Component Specific */\n.dark-theme .hover-shadow:hover,\n.light-theme .hover-shadow:hover {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n\n/* Success/Error Colors */\n.text-success {\n  color: var(--success-color) !important;\n}\n\n.text-danger {\n  color: var(--danger-color) !important;\n}\n\n.text-warning {\n  color: var(--warning-color) !important;\n}\n\n.text-info {\n  color: var(--info-color) !important;\n}\n\n/* Modal Close Button */\n.dark-theme .btn-close {\n  filter: invert(1);\n}\n\n/* Card Details Modal Specific */\n.dark-theme .modal .card,\n.light-theme .modal .card {\n  background-color: var(--bg-tertiary) !important;\n}\n\n/* Badge Colors in Theme */\n.dark-theme .badge,\n.light-theme .badge {\n  opacity: 0.9;\n}\n\n/* Nav Pills */\n.dark-theme .nav-pills .nav-link,\n.light-theme .nav-pills .nav-link {\n  color: var(--text-primary);\n}\n\n.dark-theme .nav-pills .nav-link.active,\n.light-theme .nav-pills .nav-link.active {\n  background-color: var(--primary-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
